const getConverterPrice = function (price, multiplier) {
  let displayPrice = price * multiplier;
  displayPrice = Number((Math.abs(displayPrice) * 100).toPrecision(15));

  displayPrice = (Math.round(displayPrice) / 100) * Math.sign(displayPrice);

  if (displayPrice % 1 === 0) {
    return displayPrice;
  } else {
    return displayPrice.toFixed(2);
  }
};

export { getConverterPrice };

export default {
  getConverterPrice,
};
